import { HttpEvent, HttpHandlerFn, HttpHeaders, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { filter, map, tap } from 'rxjs/operators';
import { from, Observable, switchMap } from 'rxjs';

import { KrosAuthService } from '../services/auth/kros-auth.service';


/**
 * Predicate for intercepting requests - if returns true, request will be intercepted.
 */
export type InterceptUrlPredicate = (url: string) => boolean;

/**
 * Returns functional variant of KrosAuthInterceptor.
 * @param interceptUrlPredicate
 */
export function getAuthInterceptorFn(interceptUrlPredicate: InterceptUrlPredicate): HttpInterceptorFn {
  return (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
    const authService = inject(KrosAuthService);

    if (!interceptUrlPredicate(req.url)) {
      return next(req);
    }
    return handle(req, next, authService);
  };
}

function handle(req: HttpRequest<any>, next: HttpHandlerFn, authService: KrosAuthService): Observable<HttpEvent<any>> {
  return from(authService.ensureValidToken()).pipe(
    tap(tokenIsValid => tokenIsValid || authService.startAuthentication()),
    filter(Boolean),
    switchMap(() => authService.authorizationHeaderValue),
    map(token => authHeaders(req, token, authService)),
    map(headers => req.clone({ headers })),
    switchMap(reqCloned => next(reqCloned))
  );
}

function authHeaders(req: HttpRequest<any>, token: string, authService: KrosAuthService): HttpHeaders {
  return req.headers
    .set('Authorization', token)
    .set('ApplicationType', authService.applicationTypeHeaderValue.toString());
}
